import type { classDataProps } from "../types/common";

// 老師查詢連結(/teacher/correcting-records?bookId=…&chapterId=…)開啟後的選班(kanban 1001506)。
//
// 8/28(kanban 107204)學測/模考紀錄搬到新書、班級仍掛在陪練國寫底下之後,
// 「這本書的第一個班」和「有這題紀錄的班」不再是同一個:2026-09-07 正式站查得,有 114
// 模考紀錄的 43 位老師裡 20 位開連結會落在沒紀錄的班、看到空列表。這裡逐班撈一次紀錄,
// 依班級清單原順序挑第一個有該題紀錄的班,並把撈到的紀錄一併回傳給呼叫端直接用。
//
// - 平行撈(不是逐一等),班多也不會拖太久;任一班撈失敗或回非陣列都視同沒紀錄,
//   不讓整頁載入卡住。
// - 全部沒有 → null,呼叫端落回原本「第一個班」的路徑,行為與改前一致。
// - 只在深連結帶 chapterId 且沒有 sessionStorage 還原的班級時才會被呼叫;
//   一般進入與返回還原的路徑不經過這裡。

export interface ChapterRecordLike {
  chapterID: string;
}

export interface PickedClass<R extends ChapterRecordLike> {
  cls: classDataProps;
  records: R[];
}

export async function pickClassWithChapterRecords<R extends ChapterRecordLike>(
  classes: classDataProps[],
  chapterName: string,
  fetchRecords: (classCode: string) => Promise<R[]>,
): Promise<PickedClass<R> | null> {
  if (classes.length === 0) return null;
  // 包一層 Promise.resolve().then:fetchRecords 若同步 throw(而非 reject),
  // 也要落進 allSettled 的 rejected,不能往外拋讓整頁載入中斷。
  const settled = await Promise.allSettled(
    classes.map((cls) => Promise.resolve().then(() => fetchRecords(cls.classCode))),
  );
  for (let i = 0; i < classes.length; i++) {
    const s = settled[i];
    if (s.status !== "fulfilled" || !Array.isArray(s.value)) continue;
    if (s.value.some((r) => r?.chapterID === chapterName)) {
      return { cls: classes[i], records: s.value };
    }
  }
  return null;
}
